















import Vue from 'vue';
import { BFormSelect, BFormSelectOption } from 'bootstrap-vue';

const UsaStates = require('usa-states').UsaStates;

const CA_PROVINCES = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'];

export default Vue.extend({
  name: 'StateSelect',

  components: {
    'b-form-select': BFormSelect,
    BFormSelectOption
  },

  props: {
    default: {
      type: String,
      default: ''
    },

    id: {
      type: String,
      default: 'addressState'
    },

    options: {
      type: Object,
      default: () => ({})
    },

    required: {
      type: Boolean,
      default: false
    },

    country: {
      type: String,
      default: 'US'
    }
  },

  data() {
    return {
      selected: ''
    };
  },

  computed: {
    statesArray(): Array<string> {
      if (this.country === 'CA') return CA_PROVINCES;
      var usStates = new UsaStates();
      return usStates.arrayOf('abbreviations');
    }
  },

  watch: {
    default: function () {
      this.selected = this.default;
    },

    statesArray(states: string[]) {
      if (this.selected && !states.includes(this.selected)) {
        this.selected = '';
        this.stateChanged('');
      }
    }
  },

  mounted(): void {
    if (this.default) {
      this.selected = this.default;
    }
  },

  methods: {
    stateChanged(state: string) {
      this.$emit('state-changed', state);
    }
  }
});
